/**
 * Recupera o valor de um cookie pelo nome.
 *
 * @param name - Nome do cookie que deseja buscar.
 * @returns O valor do cookie ou `''` se o cookie não existir.
 */
export function getCookieValue(name: string): string {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((row) => row.startsWith(`${name}=`));
  return cookie ? cookie.split('=')[1] : '';
}

export default {
  getCookieValue,
};
